import phoneIcon from "./assets/phone1-icon.png";
import mailIcon from "./assets/mail1-icon.png";
import locationIcon from "./assets/location-icon.png";
import gridBg from "./assets/grid_1.webp";

const HeroSection = () => {

  const cards = [
    {
      icon: phoneIcon,
      title: "Make a call",
      desc: "Let’s talk with our experts",
      content: (
        <a
          href="tel:+914448563345"
          className="text-green-700 font-semibold text-xl hover:underline"
        >
          +91-44-4856-3345
        </a>
      ),
    },
    {
      icon: mailIcon,
      title: "Send a mail",
      desc: "Don't hesitate to mail",
      content: (
        <a
          href="mailto:info@lenteratech.com"
          className="bg-white text-blue-600 px-7 py-2 rounded-full text-sm font-medium hover:underline"
        >
          info@lenteratech.com
        </a>
      ),
    },
    {
      icon: locationIcon,
      title: "Address",
      desc: "",
      content: (
        <a
          href="https://www.google.com/maps/place/Lentera+Technologies+Pvt.+Ltd./@12.9636427,80.2090835,17z/data=!3m1!4b1!4m6!3m5!1s0x3a525d628d45f3a7:0xb699ddbfaf9c98be!8m2!3d12.9636427!4d80.2116584!16s%2Fg%2F11n06vg70d?entry=ttu&g_ep=EgoyMDI2MDQwNy4wIKXMDSoASAFQAw%3D%3D"
          target="_blank"
          rel="noopener noreferrer"
          className="text-gray-700 font-medium text-sm hover:underline block"
        >
          G1, Plot No, 824 and 826, 3rd Main Rd, Ram Nagar South,
          Madipakkam, Chennai, Tamil Nadu 600091.
        </a>
      ),
    },
  ];

  return (
    <>
      {/* HERO */}
      <section
        className="pt-20 pb-36 bg-contain bg-center text-white"
        style={{ backgroundImage: `url(${gridBg})` }}
      >
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-5xl mb-4">We’d love to help you</h2>
          <p className="text-sm text-white max-w-lg mx-auto">
            Please feel free to get in touch using the form below. We'd love to
            hear your thoughts & answer any questions you may have!
          </p>
        </div>
      </section>

      {/* CARDS */}
      <section className="relative z-10 -mt-24">
        <div className="max-w-7xl mx-auto px-4">
          <div className="max-w-6xl mx-auto px-4">
            <div className="bg-white rounded-2xl shadow-2xl px-2 py-2">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">

                {cards.map((card, index) => (
                  <div
                    key={card.title} 
                    className="bg-[#f1f5f9] border border-[#D2DBE8] rounded-md p-6"
                  >
                    <img
                      src={card.icon}
                      alt={card.title}
                      className="w-10 h-10 mb-4"
                    />
                    <h3 className="text-lg font-semibold text-[#131519] mb-2">
                      {card.title}
                    </h3>
                    {card.desc && (
                      <p className="text-[#4e5a6a] mb-4">{card.desc}</p>
                    )}
                    {card.content}
                  </div>
                ))}

              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="pb-20"></div>
    </>
  );
};

export default HeroSection;